<div class="rs-checkbox">
  <mat-checkbox [formControl]="control">
    <span
      *ngIf="innerHtml; else elseBlock"
      [innerHtml]="innerHtml">
    </span>
    <ng-template #elseBlock>{{ label | translate }}</ng-template>
  </mat-checkbox>
</div>
